
































































import { Component, Prop, Watch } from 'vue-property-decorator';
import SaascadaVueDialog from '@/components/Shared/SaascadaVueDialog';
import { ProductDetailsModule } from '@/store/Products/ProductDetailsModule';
import { SubTransactionTypesModule } from '@/store/Products/SubTransactionTypesModule';
import { GeneralLedgerAccountsModule } from '@/store/Accounting/GeneralLedgerAccountsModule';
import GeneralLedgerMappingOverride from '@/models/Products/ProductGeneralLedgerMapping/GeneralLedgerMappingOverride';
import UpdateGeneralLedgerMappingOverrideRequest from '@/models/Products/ProductGeneralLedgerMapping/UpdateGeneralLedgerMappingOverrideRequest';
import ListUtils from '@/lib/listUtils';

@Component({ name: 'MappingOverridesEditDialog' })
export default class extends SaascadaVueDialog {

    @Prop( {required: true})
    mappingOverride: GeneralLedgerMappingOverride;

    dialog = false;
    request: UpdateGeneralLedgerMappingOverrideRequest = new UpdateGeneralLedgerMappingOverrideRequest(new GeneralLedgerMappingOverride(), new Date());

    @Watch('dialog')
    async onDialogChanged(val: boolean) {
        if (val) {
            this.request = new UpdateGeneralLedgerMappingOverrideRequest(this.mappingOverride, new Date());
            await SubTransactionTypesModule.getSubTransactionTypes();
            await GeneralLedgerAccountsModule.getGeneralLedgerAccountsForDialog();
        }
    }

    get transactionTypeOptions() {
        return ListUtils.transactionTypeOptions();
    }

    get subTransactionTypeOptions() {
        return SubTransactionTypesModule.subTransactionTypes;
    }

    get generalLedgerOptions() {
        return GeneralLedgerAccountsModule.generalLedgerAccountsForDialog;
    }

    get loadingSubTransactionTypeOptions() {
        return SubTransactionTypesModule.loading;
    }

    get loadingGeneralLedgerAccounts() {
        return GeneralLedgerAccountsModule.loadingGeneralLedgerAccounts;
    }

    async create() {
        if (!(this.$refs.form as any).validate()) {
            return;
        }
        else {
            this.dialog = false;

            // Set the other fields with default values
            this.request.generalLedgerAccountMappingId = ProductDetailsModule.generalLedgerMappings.id;
            this.request.state = 'ACTIVE';

            await ProductDetailsModule.editGeneralLedgerMappingOverrides(this.request);
        }
    }

}
